import React from 'react';
import { useTranslation } from 'react-i18next';
import NewReaderOverlay from '../../../NewReaderOverlay';
import { WatermarkTrackingObject } from '../NewBasisReaderOverlay';
import UnlockPremium from '../UnlockPremium';
import OfferPoints from '../../../../../Upgrade/PackageCards/OfferPoints';
import { ampliConversionPath } from '../../../../../../constants';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../../../reducers/user.selectors';

interface UpgradeInfoOverlayProps {
  trackingObject: WatermarkTrackingObject;
}

const UpgradeInfoOverlay: React.FC<UpgradeInfoOverlayProps> = ({ trackingObject }) => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);

  const getOverlayProps = () => {
    if (!user?.canUpgrade) {
      if (user?.isSchoolUser) {
        return {
          title: 'meinUnterricht 360',
          bodyText: t('Library + Tools + Professional Development'),
          offerPoints: [
            '130.000+ teaching materials',
            '8.000+ learning videos',
            '100 downloads per month',
            'Every week new content',
            'Personal collections',
            'Unlimited access to courses',
          ],
          buttonText: user?.isSchoolUser ? t('Learn more') : t('Update Plan'),
          buttonEmoji: user?.isSchoolUser ? '' : '🚀',
        };
      }

      return {
        title: 'meinUnterricht 360',
        buttonEmoji: '',
        bodyText: t('To download this document, please contact the support team for an upgrade to meinUnterricht 360.'),
      };
    }

    if (user?.isBasisUser || user?.isCourseUser) {
      return {
        title: 'meinUnterricht 360',
        bodyText: t('Library + Tools + Professional Development'),
        offerPoints: [
          '130.000+ teaching materials',
          '8.000+ learning videos',
          '100 downloads per month',
          'Every week new content',
          'Personal collections',
          'Unlimited access to courses',
        ],
        buttonText: user?.isSchoolUser ? t('Learn more') : t('Update Plan'),
        buttonEmoji: user?.isSchoolUser ? '' : '🚀',
      };
    }

    return {
      title: `meinUnterricht ${t('Premium')}`,
      offerPoints: [
        '100 downloads per month',
        'Discover content without watermarks',
        'Every week new content',
        'Limitless reading content online',
        'Videos and audio files',
        'Webinars for your further education'
      ],
      buttonText: t('Select package'),
      buttonEmoji: '🚀',
    };
  };

  const overlayProps = getOverlayProps();

  return (
    <NewReaderOverlay emoji='🚀' title={overlayProps.title}>
      <NewReaderOverlay.BodyText>
        {overlayProps.bodyText && <p>{overlayProps.bodyText}</p>}
        {overlayProps.offerPoints && <OfferPoints areAvailable={true} points={overlayProps.offerPoints} />}
      </NewReaderOverlay.BodyText>
      {overlayProps.buttonText && (
        <UnlockPremium
          emoji={overlayProps.buttonEmoji}
          text={overlayProps.buttonText}
          minditem_id={trackingObject.minditem_id}
          current_page={trackingObject.current_page}
          page_count={trackingObject.page_count}
          conversionPath={ampliConversionPath.DocumentOverlay}
        />
      )}
    </NewReaderOverlay>
  );
};

export default UpgradeInfoOverlay;
